import React from "react";
import { Route } from "react-router-dom";

function Routes({ component: Component, ...rest }) {


  return (
    <div className="open_components">
  
      <div className="open_components_details">
        {/* <div className="container position-relative"> */}
          <Route
            {...rest}
            render={(props) => (
            
                <Component {...props} />
             
            )}
          />
        {/* </div> */}
      </div>
    
    </div>
  );
}

export default Routes;